import React from "react";
import cvData from "../../data/cv";

const ACHIEVEMENT_ENRICHMENT = {
  "External Viva Examiner, Lovely Professional University": {
    id: "viva",
    shortTitle: "External Viva Examiner",
    organization: "Lovely Professional University",
    colorClass: "color-1",
    quote: "Evaluating the next generation of software engineers.",
  },
  "Recruitment Technical Lead, Internship Drive": {
    id: "recruitment",
    shortTitle: "Recruitment Technical Lead",
    organization: "Internship Drive",
    colorClass: "color-2",
    quote: "Building teams through structured technical hiring.",
  },
};

const achievements = cvData.leadershipAndRecognition.map((item) => ({
  ...item,
  ...ACHIEVEMENT_ENRICHMENT[item.title],
}));

const Achievements = () => {
  return (
    <section
      className="colorlib-achievements"
      data-section="achievements"
      id="achievements"
    >
      <div className="colorlib-narrow-content">
        <div className="row">
          <div
            className="col-md-10 col-md-offset-1 col-md-pull-1 animate-box ach-section-header"
            data-animate-effect="fadeInLeft"
          >
            <span className="heading-meta">Achievements</span>
            <h2 className="colorlib-heading animate-box">
              Leadership & recognition
            </h2>
            <p className="ach-section-subtitle">
              outside day-to-day product work
            </p>
          </div>
        </div>

        <div className="row ach-layout-6">
          {achievements.map((item, index) => (
            <div
              key={item.id}
              className="col-md-6 ach-layout-6__col animate-box"
              data-animate-effect={index % 2 === 0 ? "fadeInLeft" : "fadeInRight"}
            >
              <blockquote
                className={`ach-quote-card ach-quote-card--${item.colorClass}`}
              >
                <p className="ach-quote-card__quote">&ldquo;{item.quote}&rdquo;</p>
                <footer>
                  <strong>{item.shortTitle}</strong>
                  <span>{item.organization}</span>
                  <p>{item.description}</p>
                </footer>
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
